module.exports = __webpack_public_path__ + "img/Screenshot 2566-07-26 at 12.40.15@2x.91a89173.png";